import { Field, IFieldProps } from '@common/general-ui/field/field.component';
import { ISelectOption } from '@common/general-ui/select/select.component';
import { SerializedStyles } from '@emotion/react';
import React, { useCallback } from 'react';
import { css } from 'twin.macro';
import { CheckboxV2 } from '@common/general-ui/checkbox-v2/checkbox-v2.component';

export interface ICheckboxOption {
    label: string;
    value: boolean;
}

export type ICheckboxGroupChangeHandler = (e: { value: string[]; name: string }) => void;

export interface ICheckboxGroupProps<TName = string> extends IFieldProps<string[], TName> {
    className?: string;
    onChange?: ICheckboxGroupChangeHandler;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    options?: ISelectOption[];
    horizontalDirection?: boolean;
}

export const CheckboxGroup = (props: ICheckboxGroupProps): JSX.Element => {
    const { onChange, name, value, errorMessage, options = [] } = props;

    const handleCheckboxChange = useCallback(
        (props: { name: string; checked: boolean }): void => {
            const valueToSet = value ? [...value] : [];
            if (props.checked) {
                valueToSet.push(props.name);
            } else {
                const indexToDelete = valueToSet.indexOf(props.name);
                valueToSet.splice(indexToDelete, 1);
            }
            onChange &&
                onChange({
                    value: valueToSet,
                    name,
                });
        },
        [name, onChange, value],
    );

    return (
        <Field {...props} errorMessage={errorMessage}>
            <div tw="relative">
                <div css={styles.root(props.horizontalDirection)}>
                    {options.map((option) => (
                        <CheckboxV2
                            key={option.value}
                            value={value?.includes(option.value as string)}
                            label={option.label}
                            name={option.value as string}
                            onChange={handleCheckboxChange}
                            readOnly={props.readOnly}
                        />
                    ))}
                </div>
            </div>
        </Field>
    );
};

const styles = {
    root: (isHorizontalDirection: boolean | undefined): (SerializedStyles | boolean)[] => [
        css`
            && .ant-checkbox-wrapper {
                display: flex;
            }
        `,
        !!isHorizontalDirection &&
            css`
                display: flex;
                justify-content: space-around;
            `,
    ],
};
